<forge-text-field [invalid]="isInvalid" [required]="isRequired" [ngClass]="isDense" density="small">
  <input #input type="text" [lgdNumber]="config" [formControl]="formControl" autocomplete="off">
  @if (!hideLabel) {
    <label slot="label">{{label}}</label>
  }

  <span slot="support-text">
    @if (showErrorMessage('required')) {
      {{label}} is required
    }

    @if (showErrorMessage('pattern')) {
      Value must be a number
    }

    @if (showErrorMessage('min')) {
      {{label}} cannot be less than {{min}}
    }

    @if (showErrorMessage('max')) {
      {{label}} cannot be more than {{max}}
    }

    @if (showErrorMessage('precision')) {
      {{label}} cannot have more than {{precision}} digits
    }

    @if (showErrorMessage('scale')) {
      {{label}} cannot have more than {{scale}} digits
    }

    @if (helperTextSpacer) {
    }

    @if (hasCustomValidators) {
      @for (customError of customErrors; track customError) {
        @if (showErrorMessage(customError.errorKey)) {
          {{customError.message}}
        }
      }
    }
  </span>
</forge-text-field>